import { Chips } from '@atoms/Chips';

import {
  AUTHENTICATION_FILTER_OPTION_TEST_ID,
  AUTHENTICATION_FILTER_TEST_ID
} from './constants';
import type { AuthenticationKeyFilter } from './types';

type AuthenticationFilterProps = {
  value: AuthenticationKeyFilter;
  onChange: (next: AuthenticationKeyFilter) => void;
};

const OPTIONS: { value: AuthenticationKeyFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'enabled', label: 'Enabled' },
  { value: 'disabled', label: 'Disabled' }
];

export const AuthenticationFilter = ({
  value,
  onChange
}: AuthenticationFilterProps) => (
  <Chips<AuthenticationKeyFilter>
    data-testid={AUTHENTICATION_FILTER_TEST_ID}
    ariaLabel="Authentication key filter"
    options={OPTIONS.map((o) => ({
      ...o,
      testId: AUTHENTICATION_FILTER_OPTION_TEST_ID[o.value]
    }))}
    value={value}
    onChange={onChange}
  />
);
